import React, { Fragment } from "react"
import styled from "styled-components"
import { IComment } from "./Interfaces"
import HyperDiv from "../../../../../ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import formatFullDate from "../../../../Functions/formatFullDate"
import SmallText from "../SmallText"
import Whitespace from "../../../../../ProjectNonSpecificComponents/Elements/Whitespace"

interface Props {
	data: IComment[]
}

const CommentsScrollView = ({ data }: Props) => {
	return (
		<div id="comment-box" style={{ height: 240 }} className="overflow-y-auto pr-1">
			<Container>
				{data.map(({ author, text, timestamp }, i) => (
					<Fragment key={i}>
						<div>
							<HyperDiv direction="column">
								<SmallText>
									{author}
									{": "}
									{formatFullDate(timestamp)}
								</SmallText>
								<div>{text}</div>
							</HyperDiv>
						</div>
						{i != data.length - 1 && <Whitespace x="1.25" />}
					</Fragment>
				))}
			</Container>
		</div>
	)
}

export default CommentsScrollView

const Container = styled.div`
	word-wrap: break-word;
	padding: 11px 17px;
	border-radius: 10px;
`
